module.exports = __webpack_public_path__ + "img/6.116d70d5.png";